export default __webpack_public_path__ + "static/media/4_of_diamonds.e86dcc4c.png";